module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/1@2x_0be5af3be597ed4f9c2af742229e9cd8.png";